export default function PageHero({
  title,
  eyebrow,
  image,
  imagePosition = "center",
}) {
  return (
    <section className="relative isolate overflow-hidden bg-[#1c1c1c] text-white">
      <div
        className={
          image
            ? "relative min-h-[300px] md:aspect-[1920/440] md:min-h-[300px]"
            : "relative min-h-[260px] md:min-h-[300px]"
        }
      >
        {image && (
          <div className="absolute inset-y-0 right-0 w-full md:w-[65%]">
            <img
              src={image}
              alt=""
              fetchPriority="high"
              className="h-full w-full object-cover"
              style={{ objectPosition: imagePosition }}
            />
            <div className="absolute inset-0 bg-[#1c1c1c]/75 md:bg-[#1c1c1c]/25" />
            <div className="absolute inset-y-0 left-0 hidden w-3/4 bg-gradient-to-r from-[#1c1c1c] via-[#1c1c1c]/60 to-transparent md:block" />
          </div>
        )}

        <div className="absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-[#1c1c1c]/60 to-transparent" />

        <div className="absolute inset-0">
          <div className="mx-auto flex h-full max-w-7xl flex-col justify-end px-6 pb-8 sm:px-10 md:pb-10 lg:px-16 xl:px-10">
            {eyebrow && (
              <p className="mb-3 text-sm font-medium uppercase tracking-[0.2em] text-pink-400">
                {eyebrow}
              </p>
            )}
            <h1 className="max-w-3xl text-4xl font-bold leading-[1.15] tracking-tight md:text-5xl lg:text-6xl">
              {title}
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
}
